import {
  LOAD_USER_LOCAL_STORAGE,
  LOAD_USER_LOCAL_STORAGE_FAIL,
  LOAD_USER_LOCAL_STORAGE_SUCCESS,
  LoadUserLocalStorageSuccess,
  UserLocalStorageAction
} from "../actions";

export interface IUserLocalStorageDataState {
  userLocalStorageData: any;
  loading: boolean;
  loaded: boolean;
}

export interface IUserLocalStorageState {
  userLocalStorageData: IUserLocalStorageDataState;
}

export const initialState: IUserLocalStorageState = {
  userLocalStorageData: {
    userLocalStorageData: null,
    loading: false,
    loaded: false
  }
};

export function reducer(state: IUserLocalStorageState = initialState, action: UserLocalStorageAction): IUserLocalStorageState {
  let payload: any;

  switch (action.type) {
    case LOAD_USER_LOCAL_STORAGE:
      return {
        ...state,
        userLocalStorageData: {
          ...state.userLocalStorageData,
          loading: true,
          loaded: false
        }
      };

    case LOAD_USER_LOCAL_STORAGE_SUCCESS:
      payload = (<LoadUserLocalStorageSuccess>action).payload;

      return {
        ...state,
        userLocalStorageData: {
          ...state.userLocalStorageData,
          userLocalStorageData: payload,
          loading: false,
          loaded: true
        }
      };

    case LOAD_USER_LOCAL_STORAGE_FAIL:
      return {
        ...state,
        userLocalStorageData: {
          ...state.userLocalStorageData,
          userLocalStorageData: null,
          loading: false,
          loaded: true
        }
      };
  }

  return state;
}
